// src/Components/Footer/footerConfig.ts

/** Where a footer link sends the user. */
export type FooterTarget =
  | { kind: "route"; path: string } // internal app route via routeTo()
  | { kind: "external"; url: string } // opens in a new tab
  | { kind: "action"; action: "signIn" } // app action (Keycloak login)
  | { kind: "none" }; // shown but not linked yet (no destination)

export interface FooterLink {
  /** i18n message id for the visible label. */
  labelKey: string;
  target: FooterTarget;
}

export interface SocialLink {
  id: string;
  /** public/ path to the icon svg. */
  icon: string;
  url: string;
}

// Corporate site base (new corporate subdomain).
const CORPORATE_URL = "https://corporate.etihadrail.ae";

// Corporate deep-links default to the /en path segment. The corporate site
// serves an /ar equivalent for these pages, so on the Arabic locale we swap
// /en/ → /ar/ at render time. Other URLs (no /en/ segment) are left untouched.
export const localizeCorporateUrl = (url: string, locale: string): string =>
  locale === "ar" ? url.replace("etihadrail.ae/en/", "etihadrail.ae/ar/") : url;

export const ABOUT_LINKS: FooterLink[] = [
  { labelKey: "aboutUs", target: { kind: "external", url: `${CORPORATE_URL}/en/about/overview` } },
  { labelKey: "corporateWebsite", target: { kind: "external", url: CORPORATE_URL } },
  { labelKey: "freight", target: { kind: "external", url: `${CORPORATE_URL}/en/our-business/freight` } },
  // High speed hidden (footer) — kept commented for future re-enable.
  // { labelKey: "highSpeed", target: { kind: "none" } },
  { labelKey: "press", target: { kind: "external", url: `${CORPORATE_URL}/en/media-centre/our-news` } },
];

export const BOOK_JOURNEY_LINKS: FooterLink[] = [
  { labelKey: "login", target: { kind: "action", action: "signIn" } },
  { labelKey: "destinationsLink", target: { kind: "route", path: "/destinations" } },
  { labelKey: "journeyPlanner", target: { kind: "route", path: "/journey-planner" } },
  { labelKey: "networkMap", target: { kind: "route", path: "/networks-maps-stations" } },
  // Sitemap hidden (footer) — kept commented for future re-enable.
  // { labelKey: "sitemap", target: { kind: "none" } },
];

export const SUPPORT_LINKS: FooterLink[] = [
  { labelKey: "contactUs", target: { kind: "route", path: "/contact" } },
  { labelKey: "faqs", target: { kind: "route", path: "/help" } },
  { labelKey: "termsAndConditions", target: { kind: "route", path: "/terms-and-conditions?tab=terms-of-use" } },
  { labelKey: "privacyPolicy", target: { kind: "route", path: "/terms-and-conditions?tab=privacy-policy" } },
  { labelKey: "passengerCharter", target: { kind: "route", path: "/terms-and-conditions?tab=passenger-charter" } },
  { labelKey: "cookiesPolicy", target: { kind: "route", path: "/cookie-policy" } },
];

export const SOCIAL_LINKS: SocialLink[] = [
  { id: "facebook", icon: "/assets/social_icons/facebook.svg", url: "https://www.facebook.com/EtihadRail/" },
  { id: "linkedin", icon: "/assets/social_icons/linkedin.svg", url: "https://www.linkedin.com/company/etihad-rail/" },
  { id: "x", icon: "/assets/social_icons/twitter.svg", url: "https://x.com/Etihad_Rail" },
  { id: "instagram", icon: "/assets/social_icons/instagram.svg", url: "https://www.instagram.com/etihad_rail/" },
  { id: "youtube", icon: "/assets/social_icons/youtube.svg", url: "https://www.youtube.com/@EtihadRailUAE" },
  { id: "tiktok", icon: "/assets/social_icons/tiktok.svg", url: "https://www.tiktok.com/@etihadrail" },
];
